import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { listPossibleWorkSites } from '../../redux/actions/table/timesheets';
import styles from '../../styles/forms/timesheets/EditTimeEntryForm.scss';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';
import Checkbox from '../../components/Checkbox';
import DateTimePicker from '../../components/DateTimePicker';
import { listPossibleMeetingTasks } from '../../redux/actions/table/all_meetings';
import {
  listPossibleSpecificationProjects,
  listPossibleSpecificationStages,
} from '../../redux/actions/table/working_set_specifications';
import { enableAutosave } from '../../redux/actions/general/autosave';

@reduxForm({
  form: 'timesheets.edit_timeentry',
  enableReinitialize: true,
})
@withRouter
@subscribe(Localization, 'localization')
class EditTimeEntryForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      possible_projects: [],
      possible_stages: [],
      possible_meeting_tasks: [],
      possible_work_sites: [],
    };
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      const active_project = this.props.initialValues.project_id;
      const active_stage = this.props.initialValues.stage_id;

      listPossibleSpecificationProjects().then(({ response }) => {
        this.setState({ possible_projects: response.data });
      });

      if (active_project) {
        listPossibleSpecificationStages(active_project).then(({ response }) => {
          this.setState({ possible_stages: response.data });
        });
      }

      if (active_stage) {
        listPossibleMeetingTasks(active_stage).then(({ response }) => {
          this.setState({ possible_meeting_tasks: response.data });
        });
      }

      listPossibleWorkSites().then(({ response }) => {
        this.setState({ possible_work_sites: response.data });
      });
    }
  }

  render() {
    const possibleMinutes = [
      { value: '0', label: '00' },
      { value: 15, label: '15' },
      { value: 30, label: '30' },
      { value: 45, label: '45' },
    ];

    const {
      possible_projects,
      possible_meeting_tasks,
      possible_stages,
      possible_work_sites,
    } = this.state;

    return (
      <Form className={styles.wrapper}>
        <div className={styles.section}>
          <div className={styles.flex}></div>
          <div className={styles.flex}>
            <div className={styles.f2}>
              <Field
                name='date'
                component={DateTimePicker}
                label={__('table.columns.timesheet-date')}
                footer
              />
            </div>
            <div className={styles.f4} />
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='hours'
                component={Input}
                label={__('table.columns.timesheet-hours')}
                numeric
                maxLength={4}
                hint={__('timesheets.hint.in-hours')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                name='minutes'
                component={Select}
                searchable
                options={possibleMinutes}
                label={__('table.columns.timesheet-minutes')}
              />
            </div>
            <div className={styles.f2} />
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='project_id'
                searchable={true}
                component={Select}
                label={__('edit-timesheet-form.project')}
                options={_.map(possible_projects, (project) => ({
                  value: project.id,
                  label: [project.code, project.name].join(': '),
                }))}
                placeholder={__('edit-time-entry-form.select-project')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                name='stage_id'
                searchable={true}
                component={Select}
                label={__('edit-timesheet-form.stage')}
                options={_.map(possible_stages, (stage) => ({
                  value: stage.id,
                  label: [_.padStart(stage.order, 2, '0'), stage.name].join(
                    ': '
                  ),
                }))}
                placeholder={__('edit-time-entry-form.select-stage')}
              />
            </div>
          </div>
          <Field
            name='task_id'
            searchable={true}
            component={Select}
            label={__('edit-timesheet-form.task')}
            options={_.map(possible_meeting_tasks, (task) => ({
              value: task.id,
              label: ['T-', task.identifier, ': ', task.title],
            }))}
            placeholder={__('edit-time-entry-form.select-task')}
          />
          <Field
            name='work_site_id'
            searchable={true}
            component={Select}
            label={__('edit-timesheet-form.work-site')}
            options={_.map(possible_work_sites, (workSite) => ({
              value: workSite.id,
              label: workSite.name,
            }))}
            placeholder={__('edit-time-entry-form.select-location')}
          />
          <Field
            name='description'
            component={Textarea}
            label={__('edit-timesheet-form.description')}
            maxLength={200}
            rows={1}
            maxRows={5}
            placeholder={__('edit-time-entry-form.add-description')}
          />
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='is_billable'
                component={Checkbox}
                label={__('edit-timesheet-form.nonbillable')}
                className={styles.checkbox}
                onChange={(event) => {}}
              />
            </div>
            <div className={styles.f5}>
              <Field
                name='is_makeup_time'
                component={Checkbox}
                label={__('edit-timesheet-form.not_overtime')}
                className={styles.checkbox}
              />
            </div>
          </div>
        </div>
      </Form>
    );
  }
}

export default EditTimeEntryForm;
